export default __webpack_public_path__ + "static/media/luggage-cart-solid.d7a2e8da.svg";